const state = {
  stepNumber: 0,
  numberOfAdults: 1,
  businessRegistration: false,
};

const mutations = {
  CHANGE_STEP_NUMBER(state, payload) {
    state.stepNumber = payload;
  },
  CHANGE_ADULTS_NUMBER(state, payload) {
    state.numberOfAdults = payload;
  },
  CHANGE_BUSINESS_REGISTRATION(state, payload) {
    state.businessRegistration = payload;
  },
};

export default {
  state,
  mutations,
};
